<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-01-31 17:49:22
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-08 18:26:52
 * @Description: file content
 -->
<template>
  <div class="t9_zq">
    <img class="rule" :src="rulesrc" alt />
    <!-- <div>
      1、进入“我要赚钱”活动页面，无需繁琐注册和实名认证即可参与本活动.
      2、注册成功后，你可以分享楼盘信息给朋友们，一但您的好友浏览或则对我们项目感兴趣，留下电话，进行咨询，进而到访。我们都有尊贵专项的现金红包和精美礼品相送哟。把我们的精彩楼盘信息分享给更多的朋友，一起来赚钱！
    </div>-->
    <div class="btn1" v-if="isShowRegister" @click="clickRegister">{{ruletxt}}</div>
    <div class="btn1" v-if="isShowSaoMa" @click="clickSaoMa">领取合伙人二维码</div>
    <div class="line"></div>
    <!-- <div class="txt2">直接扫码转发内容开始赚钱</div> -->
    <img class="poster" v-if="posterUrl" :src="posterUrl" alt />
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>

<script>
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import util from "@/utils/utils";
import Canvastoimg from "wtc-canvastoimg";
import upload from "@/utils/upload";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
export default {
  components: {
    BtnBackLayout4
  },
  props: {},
  data() {
    return {
      rulesrc: "",
      ruletxt: "",
      bgUrl: "",
      bottomBgUrl:
        "http://assets.rurushishi.com/web6006/wx01f0b018d4951434/1580566442000-50.png",
      bottomTxt: "",
      qrcodeUrl: "",
      posterUrl: "",
      isShowRegister: false,
      getMoneyPosterUrl: "",
      isShowSaoMa: false
    };
  },
  watch: {},
  computed: {
    ...mapState(["pageInfo", "userInfo", "isInMiniProgram", "shareSpreadInfo"])
  },
  methods: {
    clickRegister() {
      this.$router.push("t9_my");
    },
    createImg1() {
      this.$setLoading(true);
      const sharpness = 2; //清晰度
      let cvsImgData = [
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 2,
          x: 0,
          y: 0,
          width: 828 * sharpness,
          height: 1476 * sharpness,
          content: this.bgUrl
        },
        {
          type: "img",
          zIndex: 3,
          x: 0 * sharpness,
          y: (1476 - 180) * sharpness,
          width: 828 * sharpness,
          height: 180 * sharpness,
          content: this.bottomBgUrl
        },
        {
          type: "img",
          shape: "arc",
          zIndex: 4,
          x: 10 * sharpness,
          y: (1476 - 170) * sharpness,
          width: 160 * sharpness,
          height: 160 * sharpness,
          content: this.userInfo.user.headimgurl
        },
        {
          type: "img",
          zIndex: 4,
          x: (828 - 170) * sharpness,
          y: (1476 - 170) * sharpness,
          width: 160 * sharpness,
          height: 160 * sharpness,
          content: this.qrcodeUrl
        }
      ];

      (() => {
        // 中间的文字
        let tmpStrList = [];
        let tmpStrListIndex = 0;
        let title = this.userInfo.user.name || this.userInfo.user.nickname;
        title += "：";
        title += this.bottomTxt;

        // title = "一二三四五六七八九十一";
        // title = "一二三四五六七八九十一二三四五六七八九十";
        // title =
        //   "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
        for (let index = 0; index < title.length; index++) {
          if (
            tmpStrListIndex == 0 ||
            tmpStrListIndex >= 30 * tmpStrList.length
          ) {
            tmpStrList.push(title[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += title[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += util.getStrBlen(title[index]);
        }
        let stringYStartValue = 0;
        if (tmpStrList.length == 1) {
          stringYStartValue = 1476 - 160 + 80 - 20;
        } else if (tmpStrList.length == 2) {
          stringYStartValue = 1476 - 160 + 80 - 20 - 30;
        } else if (tmpStrList.length >= 3) {
          stringYStartValue = 1476 - 160 + 80 - 20 - 30 - 10;
        }
        // 最多展示三行
        if (tmpStrList.length > 3) {
          tmpStrList = tmpStrList.slice(0, 3);
        }
        for (let index = 0; index < tmpStrList.length; index++) {
          let stringX = 0;
          let stringY = 0;
          if (tmpStrList.length == 1) {
            // stringX =
            //   60 +
            //   (255 - (this.$util.getStrBlen(tmpStrList[index]) / 2) * 14) / 2; //原本的x值+（方框宽度-字符串宽度）/2 居中的写法
            stringX = 10 + 160 + 20;
            stringY = stringYStartValue;
          } else {
            stringX = 10 + 160 + 20;
            stringY = stringYStartValue + 40 * index;
          }
          let item = {
            type: "text",
            zIndex: 4,
            fontSize: `${30 * sharpness}px 微软雅黑`,
            x: stringX * sharpness,
            y: stringY * sharpness,
            content: tmpStrList[index],
            color: "#ffffff"
          };
          cvsImgData.push(item);
        }
      })();
      const cvsimg = new Canvastoimg({
        width: 828 * sharpness, //画布宽度
        height: 1476 * sharpness, //画布高度
        color: "#ffffff", //画布背景色
        data: cvsImgData
      });

      cvsimg.down().then(canvas => {
        /* 获取到的是canvas对象 */
        this.posterUrl = canvas.toDataURL("image/jpg");
        this.$setLoading(false);
      });
    },
    // 用配置的神码图的背景图
    init1() {
      if (this.pageInfo.Extinfo && this.pageInfo.Extinfo.content_channel_tags) {
        comreq
          .getSmPicByTagAndQrtype(
            parseInt(this.pageInfo.Extinfo.content_channel_tags)
          )
          .then(data => {
            console.log("getSmPicByTagAndQrtype", data);
            if (
              data.code == 0 &&
              data.obj &&
              data.obj.pic_url &&
              data.obj.id &&
              data.obj.content
            ) {
              this.bgUrl = data.obj.pic_url.replace("https://", "http://");
              this.bottomTxt = data.obj.content;
              comreq
                .createUserPic(data.obj.id, data.obj.content)
                .then(data2 => {
                  console.log("createUserPic", data2);
                  if (data2.code == 0 && data2.obj && data2.obj.qrcode) {
                    comreq.base64(data2.obj.qrcode).then(data3 => {
                      this.qrcodeUrl = data3;
                      this.createImg1();
                    });
                  }
                });
            }
          });
      }
      comreq.getUserIntegralInfo().then(userInfo => {
        if (userInfo.isSale == false && userInfo.isAgent == false) {
          this.isShowRegister = true;
        }
      });
    },
    createImg2() {
      this.$setLoading(true);
      const sharpness = 2; //清晰度
      let cvsImgData = [
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 2,
          x: 0,
          y: 0,
          width: 1093 * sharpness,
          height: 1468 * sharpness,
          content: this.bgUrl
        },
        {
          type: "img",
          zIndex: 4,
          x: ((1093 - 200) / 2) * sharpness,
          y: (1468 - 200 - 100) * sharpness,
          width: 200 * sharpness,
          height: 200 * sharpness,
          content: this.qrcodeUrl
        }
      ];

      const cvsimg = new Canvastoimg({
        width: 1093 * sharpness, //画布宽度
        height: 1468 * sharpness, //画布高度
        color: "#ffffff", //画布背景色
        data: cvsImgData
      });

      cvsimg.down().then(canvas => {
        /* 获取到的是canvas对象 */
        this.posterUrl = canvas.toDataURL("image/jpg");
        this.$setLoading(false);
      });
    },
    // 未注册任意角色的时候，生成神码图
    createSmPoster() {
      if (this.pageInfo.Extinfo && this.pageInfo.Extinfo.content_channel_tags) {
        comreq
          .getSmPicByTagAndQrtype(
            parseInt(this.pageInfo.Extinfo.content_channel_tags)
          )
          .then(data => {
            console.log("getSmPicByTagAndQrtype", data);
            if (
              data.code == 0 &&
              data.obj &&
              data.obj.pic_url &&
              data.obj.id &&
              data.obj.content
            ) {
              this.bgUrl =
                "http://assets.rurushishi.com/yq-rs-make/t9_zq/poster_bg.png";
              comreq
                .createUserPic(data.obj.id, data.obj.content)
                .then(data2 => {
                  console.log("createUserPic", data2);
                  if (data2.code == 0 && data2.obj && data2.obj.qrcode) {
                    comreq.base64(data2.obj.qrcode).then(data3 => {
                      this.qrcodeUrl = data3;
                      this.createImg2();
                    });
                  }
                });
            }
          });
      }
    },
    createImg3() {
      this.$setLoading(true);
      const sharpness = 2; //清晰度
      let cvsImgData = [
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 2,
          x: 0,
          y: 0,
          width: 1093 * sharpness,
          height: 1468 * sharpness,
          content: this.bgUrl
        },
        {
          type: "img",
          zIndex: 4,
          x: ((1093 - 200) / 2) * sharpness,
          y: (1468 - 200 - 100) * sharpness,
          width: 200 * sharpness,
          height: 200 * sharpness,
          content: this.qrcodeUrl
        }
      ];

      const cvsimg = new Canvastoimg({
        width: 1093 * sharpness, //画布宽度
        height: 1468 * sharpness, //画布高度
        color: "#ffffff", //画布背景色
        data: cvsImgData
      });

      cvsimg.down().then(canvas => {
        /* 获取到的是canvas对象 */
        let posterUrl = canvas.toDataURL("image/jpg");
        upload.uploadBase64ToOss(posterUrl).then(data => {
          this.getMoneyPosterUrl = data;
          setTimeout(() => {
            this.getMoneyPosterUrl = "";
          }, 1000 * 60 * 30);
          util.zxslzxNavigateToShareMomentsRespImageTxt(
            this,
            this.getMoneyPosterUrl
          );
          this.$setLoading(false);
        });
      });
    },
    // 未注册任意角色的时候，生成神码图 小程序环境下
    createSmPosterForXcx() {
      if (this.pageInfo.Extinfo && this.pageInfo.Extinfo.content_channel_tags) {
        comreq
          .getSmPicByTagAndQrtype(
            parseInt(this.pageInfo.Extinfo.content_channel_tags)
          )
          .then(data => {
            console.log("getSmPicByTagAndQrtype", data);
            if (
              data.code == 0 &&
              data.obj &&
              data.obj.pic_url &&
              data.obj.id &&
              data.obj.content
            ) {
              this.bgUrl =
                "http://assets.rurushishi.com/yq-rs-make/t9_zq/poster_bg.png";
              comreq
                .createUserPic(data.obj.id, data.obj.content)
                .then(data2 => {
                  console.log("createUserPic", data2);
                  if (data2.code == 0 && data2.obj && data2.obj.qrcode) {
                    comreq.base64(data2.obj.qrcode).then(data3 => {
                      this.qrcodeUrl = data3;
                      this.createImg3();
                    });
                  }
                });
            }
          });
      }
    },
    // 小程序环境下，点击按钮领取合伙人二维码
    clickSaoMa() {
      if (this.getMoneyPosterUrl) {
        util.zxslzxNavigateToShareMomentsRespImageTxt(
          this,
          this.getMoneyPosterUrl
        );
      } else {
        this.createSmPosterForXcx();
      }
    }
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
      comreq.getUserIntegralInfo().then(userInfo => {
        if (userInfo.isSale == false && userInfo.isAgent == false) {
          this.isShowRegister = true;
        }
      });
      if (this.isInMiniProgram) {
        // 悦房云在小程序环境下，隐藏领取合伙人二维码
        if (this.global.SUBDOMAIN != "yuefangy") {
          this.isShowSaoMa = true;
        }
      } else {
        this.createSmPoster();
      }
    });
  },
  mounted() {
    let that = this;
    if (util.checkIsHuafa()) {
      that.rulesrc = "https://assets.rurushishi.com//yq-rs-make/t9_zq/rule5.png";
      that.ruletxt = "注册成为合伙人";
    } else {
      that.rulesrc =
        "https://assets.rurushishi.com//yq-rs-make/t9_zq/rule3.png?x-oss-process=image/resize,p_40";
      that.ruletxt = "注册免费领取获客功能";
    }
  }
};
</script>
<style lang="css" scoped>
.t9_zq > img {
  width: 90%;
  margin-left: 5%;
}
.rule {
  margin-top: 0.4rem;
}
.poster {
  margin-top: 0.3rem;
}
.btn1 {
  border: 1px solid #ef8532;
  color: #ef8532;
  width: 80%;
  height: 1rem;
  line-height: 1rem;
  border-radius: 0.5rem;
  font-size: 0.35rem;
  text-align: center;
  margin: 0.3rem auto;
}
.line {
  width: 100%;
  height: 5px;
  background-color: #f5f5f5;
  margin-top: 0.25rem;
}
.txt2 {
  font-size: 0.35rem;
  text-align: center;
  margin: 0.3rem auto;
  color: rgba(87, 89, 89, 1);
}
</style>